import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { GetLeadByELauchIdGQL } from "../../../../generated/graphql";
import { SnackBarService } from "../../service/snack.bar.service";

export interface DialogData {
  eLaunchId: string,
  recipientList: []
}

@Component({
  selector: "email-contact-dialog",
  templateUrl: "email-contact-dialog.html",
  styleUrls: ["./email-contact-dialog.css"]
})

export class EmailContactDialog {
  contactList: any;
  value: any;
  selected: any = [];
  eLaunchId: string;
  constructor(
    private getLeadByELauchIdGQL: GetLeadByELauchIdGQL,
    private snackBarService: SnackBarService,
    public dialogRef: MatDialogRef<EmailContactDialog>,
    @Inject(MAT_DIALOG_DATA) private data: DialogData
  ) {
    this.eLaunchId = this.data?.eLaunchId;
    this.getData();
  }

  private getData() {
    this.getLeadByELauchIdGQL.fetch({eLaunchId: this.eLaunchId}).subscribe((result) => {
      if (result.errors) {
        this.snackBarService.showQueryError(result.errors);
      }
      this.contactList = result.data.getLeadByELaunchId;
      this.selected = this.data.recipientList;
    })
  }

  submit() {
    if (this.selected) {
      this.dialogRef.close({
        selectedEmails: this.selected.map(x => x?.email),
        altEmails: this.selected.map(x => x.altEmail)?.filter(x => x != null)[0],
        leadContactIds: this.selected.map(x => x?.contactId)
      }
      );
    }
  }

}
